import _ from 'lodash';
import logger from '@/logger';
import { checkLogin, login, logout } from './api';

const emptyPromise = () => {
  let res;
  const p = new Promise((resolve) => { res = resolve; });
  p.resolve = (val) => {
    p.resolved = true;
    res(val);
  };
  return p;
};

const initialState = {
  status: 'unauthenticated',
  loginChecked: false,
  error: null,
  user: null,
  loginCheckedP: emptyPromise(),
};

const mutations = {
  LOGGING_IN(state) {
    state.status = 'pending';
    state.error = null;
  },
  SUCCESS(state, user) {
    state.status = 'logged_in';
    state.error = null;
    state.user = user;
  },
  FAILURE(state, error) {
    state.status = 'unauthenticated';
    state.error = error;
  },
  LOGOUT(state) {
    state.status = 'unauthenticated';
    state.user = null;
    state.error = null;
  },
  CHECKING_LOGIN(state) {
    if (state.loginCheckedP.resolved) {
      state.loginCheckedP = emptyPromise();
    }
  },
  CHECKED(state) {
    state.loginChecked = true;
    state.loginCheckedP.resolve(state.status === 'logged_in');
  },
};

const actions = {
  async checkLogin({ commit }) {
    commit('CHECKING_LOGIN');
    logger.log('checkLogin kicked off');
    const user = await checkLogin();
    logger.log('login checked. user is', user);
    if (user) commit('SUCCESS', user);
    commit('CHECKED');
    logger.log('all done checking');
  },
  async logIn({ commit }, { email, password }) {
    commit('LOGGING_IN');
    commit('CHECKING_LOGIN');
    try {
      const user = await login({ email, password });
      commit('SUCCESS', user);
      commit('CHECKED');
    } catch (e) {
      commit('FAILURE', e);
    }
    commit('CHECKED');
  },
  logOut({ commit }) {
    logout();
    commit('LOGOUT');
  },
};

const getters = {
  loggedIn(state) { return state.status === 'logged_in'; },
  admin(state, gettrs) {
    return gettrs.loggedIn && _.includes(state.user.groups, 'admin');
  },
  empty() { return null; },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  hagridResources: {
    checkLogin: 'empty',
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Login.js